import { StepValue } from '../stepper';

export const getDotStyles = (value: StepValue): Record<string, string> => {
  if (value === StepValue.COMPLETE) {
    return {
      backgroundColor: 'primary.main',
      borderColor: 'primary.main',
    };
  }

  if (value === StepValue.ACTIVE) {
    return {
      borderColor: 'primary.main',
      color: 'primary.main',
    };
  }

  return {
    backgroundColor: 'inherit',
    borderColor: 'neutral.300',
    color: 'text.secondary',
  };
};
